export const LEGAL_TERMS_OF_USE_CANCELLATION_POLICIES: string = `

### <!--= ++sectionIndex -->. Stornierungsrichtlinien
<!-- subSectionIndex = 0; -->

#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Stornierung und Rückerstattung (SAAS)

Sie haben das gesetzliche Recht, Ihr Abonnement jederzeit zu kündigen, wie in den entsprechenden Kündigungsanweisungen beschrieben. Weitere Einzelheiten zur Kündigung finden Sie in der <button class="btn btn-link p-0" routerLink="cancellation-policy">Kündigungsrichtlinie</button>.

Jeder Benutzer hat nach dem Erstkauf der Software Anspruch auf eine 14-tägige Geld-zurück-Garantie. Nach automatischer Verlängerung des Abonnements werden keine Rückerstattungen gewährt. Weitere Einzelheiten finden Sie in unseren <button class="btn btn-link p-0" routerLink="cancellation-policy">Stornierungsbedingungen</button>.

Bitte beachten Sie, dass die unten und in den **Rückerstattungsbedingungen** angegebenen Einschränkungen gelten können und Ihr Recht auf Rückerstattung möglicherweise beeinträchtigen könnten.
`;
